module.exports = __webpack_public_path__ + "img/Waiver.c35b5714.svg";